import { PublicInfoPage } from "@/pages/PublicInfoPage";

export function CareersPage() {
  return (
    <PublicInfoPage
      canonicalPath="/careers"
      description="Explore careers at Liminl and connect with the team building relationship intelligence for human-centered career navigation."
      documentTitle="Careers at Liminl | Build the Future of Career Connection"
      headingId="careers-title"
      navItems={[
        { href: "#always-hiring", label: "We are always hiring" },
        { href: "#warm-intro", label: "Find a warm intro" },
        { href: "#always-networking", label: "We are always networking" },
        { href: "#careers-contact", label: "Reach out" },
      ]}
      pageMeta="Last updated 4 July 2026"
      title="Careers"
    >
      <section id="always-hiring">
        <h2>We are always hiring</h2>
        <p>
          Liminl is always looking for exceptional people. We do not wait for a role to open to
          meet someone great, so if the work resonates with you, reach out. The best introductions
          rarely come through a job board.
        </p>
      </section>

      <section id="warm-intro">
        <h2>Find a warm intro</h2>
        <p>
          We practice what we build. The strongest way to reach us is the way Liminl is designed
          to work: through a warm path. If you know someone connected to the team, ask them for an
          introduction. If you do not, write to us anyway and tell us what you would want to build
          here.
        </p>
      </section>

      <section id="always-networking">
        <h2>We are always networking</h2>
        <p>
          There is no closing date and no single opening. We are always networking, always meeting
          people, and always keeping the door open. Tell us where you are and where you want to go,
          and we will keep the conversation warm.
        </p>
      </section>

      <section id="careers-contact">
        <h2>Reach out</h2>
        <p>
          Email us at <a href="mailto:nicole@goliminl.com">nicole@goliminl.com</a>. Share what pulls
          you toward Liminl and how you like to work. We read every note.
        </p>
      </section>
    </PublicInfoPage>
  );
}
